<template>
  <div :class="$style.container">
    <!-- TODO: @danealton это следует вынести в отдельный компонент -->
    <p
      v-if="isPersonalProject"
      :class="$style.template">
      <base-icon
        v-m-r="5"
        :size="16"
        name="shopping_coupon"
      />
      <span :class="$style.link" @click="handleTemplateEditing">
        <span v-text-decoration:underline>{{ $t('bill.ticket.blank') }}</span>
        <base-icon
          v-m-l="5"
          :size="16"
          name="basic_pen-create"
        />
      </span>
    </p>
    <p v-if="transaction.multiBill" v-html="displaySalesProgress" />
    <p v-if="arrangement.countPerPayment" v-html="displayLimitForPerson" />
    <p v-if="arrangement.countBundle" v-html="displayCountPerPayment" />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import { EVENT_BUS } from '@/eventBus';

export default {
  name: 'TicketInformation',
  props: {
    tariff: {
      type: Object,
      required: true,
    },
    transaction: {
      type: Object,
      required: true,
    },
  },
  computed: {
    arrangement() {
      return this.tariff.arrangement;
    },
    displaySalesProgress() {
      const { countSold, count } = this.arrangement;

      if (this.$validate.isPositiveNumber(count)) {
        return `${this.$t('bill.ticket.sold.count')}: <strong>${countSold} / ${count}</strong>`;
      }

      return `${this.$t('bill.ticket.sold.count')}: <strong>${countSold}</strong>`;
    },
    displayLimitForPerson() {
      const { countPerPayment } = this.arrangement;

      if (!this.$validate.isPositiveNumber(countPerPayment)) {
        return '';
      }

      return `${this.$t('bill.ticket.limit.for.person')}: <strong>${countPerPayment}</strong>`;
    },
    displayCountPerPayment() {
      const { countBundle } = this.arrangement;

      if (!this.$validate.isPositiveNumber(countBundle)) {
        return '';
      }

      return `${this.$t('bill.ticket.count.per.payment')}: <strong>${countBundle}</strong>`;
    },
    ...mapGetters([
      'isPersonalProject',
    ]),
  },
  methods: {
    handleTemplateEditing() {
      this.SET_TICKET_EDITING(this.tariff);
      EVENT_BUS.$emit('EVENT_EDIT_TICKET_TEMPLATE');
    },
    ...mapMutations('ticket', ['SET_TICKET_EDITING']),
  },
};
</script>

<style lang="sass" module>
  .container
    +font-type(regular, 12, 18)
    color: var(--color-black-2)

  .template
    +flexbox
    +align-items(center)
    +font-type(medium, 14, 20)
    margin-bottom: 8px

    a
      color: var(--color-black-2)
      text-decoration: underline

      &:hover
        text-decoration: none

  .link
    cursor: pointer
</style>
